angular.module('ikeweb.event').value('events', {
    SUBSCRIPTION: {
        CREATED: 'subscription.created',
        CANCELED: 'subscription.canceled'
    },
    FOLDER: {
        SELECTED: 'folder.selected',
        FOCUS: 'folder.focus',
        UPDATED: 'folder.updated',
        DROPPED: 'folder.droppped',
        NEW_FOCUS: 'folder.newfocus',
        CAPTURE: {
            DROPPED: 'folder.capture.dropped'
        }
    },
    NOTE: {
        SELECTED: 'note.selected',
        FOCUS: 'note.focus'
    },
    BILLING: {
        PURCHASE_PREMIUM: {
            DISPLAY: 'billing.purchase_premium.display',
            DISMISS: 'billing.purchase_premium.dismiss',
            SELECT_CURRENT_PLAN: 'billing.purchase_premium.select_current_plan'
        },
        PURCHASE_TRIAL: {
            DISPLAY: 'billing.purchase_trial.display'
        },
        PURCHASE: {
            DISPLAY_MODAL: 'billing.purchase.display_modal',
            DISMISS_MODAL: 'billing.purchase.dismiss_modal'
        }
    },
    SHARING: {
        DISPLAY_SHARE_URL: 'display.share.url',
        DISMISS_SHARE_URL: 'dismiss.share.url'
    },
    EXPORT: {
        DISMISS_EXPORT_SELECTOR: 'export.dismiss.export.selector',
        DISPLAY_EXPORT_SELECTOR: 'export.display.export.selector',
        DOWNLOAD: {
            COMPOSITE: 'export.download.composite',
            DESKEWED: 'export.download.deskewed',
            IMAGEONLY: 'export.download.imageonly'
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ./src/client/event/events.js
// module id = 439
// module chunks = 0